window.initImageLoad = () => {
	let imagesToLoad = document.querySelectorAll('img[data-src]');
	if (imagesToLoad) {
		const loadImages = image => {
			const imageSRC = image.getAttribute('data-src');
			if (imageSRC) {
				image.setAttribute('src', imageSRC);
				image.onload = () => {
					image.removeAttribute('data-src');
					image.classList.remove('preload');
					image.parentNode.classList.remove('preload');
				};
			}
		};
		if ('IntersectionObserver' in window) {
			const observer = new IntersectionObserver((items, observer) => {
				items.forEach(item => {
					if (item.isIntersecting) {
						loadImages(item.target);
						observer.unobserve(item.target);
					}
				});
			});
			imagesToLoad.forEach(img => {
				observer.observe(img);
			});
		} else {
			imagesToLoad.forEach(img => {
				loadImages(img);
			});
		}
	}
};
window.addEventListener('DOMContentLoaded', window.initImageLoad);
